import Vue from 'vue'
import Constants from 'src/utilities/constants'
import {make} from 'vuex-pathify'

const initialState = {
  edit: {
    name: null,
    projectType: null,
    notesByDepartment: {},
    departments: [],
    active: true,
    createdBy: null,
    updatedBy: null,
    project: null,
    address: {
      city: null,
      county: null,
      state: Constants.ATS.DEFAULT.STATE,
      zip: null,
      streetNumber: null,
      suiteNumber: null,
      buildingNumber: null,
      floorNumber: null,
      streetName: null,
      jurisdiction: null,
      lotNumber: null,
      blockNumber: null,
      phase: null,
      section: null,
      legalDescription: null,
      legalSubdivisionId: null
    }
  },
  remember: {
    city: false,
    county: false,
    state: false,
    zip: false,
    suiteNumber: false,
    buildingNumber: false,
    floorNumber: false,
    streetNumber: false,
    streetName: false,
    jurisdiction: false,
    lotNumber: false,
    blockNumber: false,
    phase: false,
    section: false,
    legalDescription: false,
    legalSubdivisionId: false
  }
}

const state = Vue.util.extend({}, JSON.parse(JSON.stringify(initialState)))

const getters = make.getters(state)
const mutations = make.mutations(state)

mutations.reset = (state) => {
  // doing this manually - wasn't resetting address correctly
  state.edit.name = null
  state.edit.notesByDepartment = {}
  state.edit.projectType = null
  state.edit.departments = []
  state.edit.active = true
  state.edit.createdBy = null
  state.edit.updatedBy = null

  for (let f in state.edit.address) {
    if (!state.remember[f]) {
      state.edit.address[f] = null
    }
  }

  state.edit.address.state = Constants.ATS.DEFAULT.STATE
}

mutations.addDepartment = (state, departmentId) => {
  if (!state.edit.departments.includes(departmentId)) {
    state.edit.departments.push(departmentId)
  }
}

mutations.updateProjectNotes = (state, payload) => {
  state.edit.notesByDepartment[payload.departmentId] = payload.notes
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
